/* a-sk-ugc: opinie klientek ze zdjęciami (sekcje hm-sk-home-ugc i hm-sk-reviews-wall), 29.10.2026.
   Wszystkie karty renderuje Liquid. Ten plik zmienia DOM wyłącznie przez textContent, klasy, atrybuty (hidden, aria-*, style
   grid-row-end) — bez wstawiania surowego HTML. Brak logiki koszyka.
   1) [data-sk-ugc]  strona główna: zakładki (role=tab), tor karuzeli ze scroll-snap, strzałki, autoprzewijanie co data-autoplay ms
      (pauza przy najechaniu, fokusie i dotyku; stop po pierwszej interakcji: strzałka, zakładka, przesunięcie toru palcem,
      gładzikiem w bok albo klawiszem; przycisk z etykietą Pause/Play (bez aria-pressed, jeden sygnał dla czytnika)
      pauzy/odtwarzania; tylko gdy sekcja jest na ekranie i karta przeglądarki widoczna; wyłączone przy prefers-reduced-motion).
   2) [data-sk-rw]   karta produktu: filtry, „Show more reviews” (+data-step), „Read more” w karcie, licznik, układ muru. */
(function () {
  var RM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var BH = RM ? 'auto' : 'smooth';
  function all(r, s) { return [].slice.call(r.querySelectorAll(s)); }

  /* 1 · karuzela na stronie głównej */
  function ugc(root) {
    if (root.dataset.skInit) return; root.dataset.skInit = '1';
    var tabs = all(root, '[data-ugc-tab]'), panels = all(root, '[data-ugc-panel]');
    var prev = all(root, '[data-ugc-prev]'), next = all(root, '[data-ugc-next]'), pauses = all(root, '[data-ugc-pause]');
    var ms = parseInt(root.getAttribute('data-autoplay') || '0', 10) || 0;
    var auto = ms > 0 && !RM, playing = auto, hov = false, foc = false, tch = false, tchT = null, inView = false, timer = null;

    function panel() { return panels.filter(function (p) { return !p.hidden; })[0] || panels[0]; }
    function track() { var p = panel(); return p ? p.querySelector('[data-ugc-track]') : null; }
    function stepW(tr) { var c = tr.children; return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : tr.clientWidth; }
    function maxL(tr) { return tr.scrollWidth - tr.clientWidth; }
    function upd() {
      var tr = track(); if (!tr) return;
      var m = maxL(tr);
      prev.forEach(function (b) { b.disabled = tr.scrollLeft < 4; });
      next.forEach(function (b) { b.disabled = tr.scrollLeft >= m - 4; });
    }
    function syncPause() {
      pauses.forEach(function (b) {
        b.hidden = !auto;
        b.classList.toggle('is-paused', !playing);
        var ip = b.querySelector('.sk-ugc-i-pause'), il = b.querySelector('.sk-ugc-i-play'), t = b.querySelector('[data-ugc-pause-txt]');
        if (ip) ip.hidden = !playing;
        if (il) il.hidden = playing;
        if (t) t.textContent = playing ? (root.getAttribute('data-pause-label') || 'Pause') : (root.getAttribute('data-play-label') || 'Play');
      });
    }
    function stop() { playing = false; syncPause(); }
    function go(dir, isAuto) {
      var tr = track(); if (!tr) return;
      if (dir > 0 && isAuto && tr.scrollLeft >= maxL(tr) - 4) tr.scrollTo({ left: 0, behavior: BH });
      else tr.scrollBy({ left: dir * stepW(tr), behavior: BH });
    }
    function tick() { if (playing && !hov && !foc && !tch && inView && !document.hidden) go(1, true); }
    function select(key, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-ugc-tab') === key;
        t.classList.toggle('on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-ugc-panel') !== key; });
      var tr = track(); if (tr) tr.scrollLeft = 0;
      upd();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { stop(); select(t.getAttribute('data-ugc-tab')); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, j = -1;
        if (k === 'ArrowRight') j = (i + 1) % tabs.length; else if (k === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') j = 0; else if (k === 'End') j = tabs.length - 1;
        if (j < 0) return;
        e.preventDefault(); stop(); select(tabs[j].getAttribute('data-ugc-tab'), true);
      });
    });
    prev.forEach(function (b) { b.addEventListener('click', function () { stop(); go(-1); }); });
    next.forEach(function (b) { b.addEventListener('click', function () { stop(); go(1); }); });
    pauses.forEach(function (b) { b.addEventListener('click', function () { playing = !playing; syncPause(); }); });

    all(root, '[data-ugc-track]').forEach(function (tr) {   // interakcja człowieka z torem = stop (zdarzenia wejścia, nie samo „scroll”)
      var q = false, sx = 0, sy = 0;
      tr.addEventListener('scroll', function () { if (!q) { q = true; requestAnimationFrame(function () { q = false; upd(); }); } }, { passive: true });
      tr.addEventListener('touchstart', function (e) { tch = true; clearTimeout(tchT); var t0 = e.touches[0]; sx = t0.clientX; sy = t0.clientY; }, { passive: true });
      tr.addEventListener('touchmove', function (e) { var t0 = e.touches[0], dx = Math.abs(t0.clientX - sx), dy = Math.abs(t0.clientY - sy); if (dx > 8 && dx > dy) stop(); }, { passive: true });
      tr.addEventListener('touchend', function () { clearTimeout(tchT); tchT = setTimeout(function () { tch = false; }, 1500); }, { passive: true });
      tr.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) stop(); }, { passive: true });
      tr.addEventListener('keydown', function (e) { if (/^(Arrow|Page|Home|End)/.test(e.key)) stop(); });
    });
    root.addEventListener('mouseenter', function () { hov = true; });
    root.addEventListener('mouseleave', function () { hov = false; });
    root.addEventListener('focusin', function () { foc = true; });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) foc = false; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { inView = e.isIntersecting; }); }, { threshold: 0.35 }).observe(root);
    } else { inView = true; }
    syncPause(); upd();
    window.addEventListener('resize', upd);
    if (auto) timer = setInterval(tick, ms);
    root._skUgc = { stop: stop, state: function () { return { playing: playing, hov: hov, foc: foc, tch: tch, inView: inView, auto: auto }; } };
  }

  /* 2 · ściana opinii na karcie produktu */
  function rw(root) {
    if (root.dataset.skInit) return; root.dataset.skInit = '1';
    var grid = root.querySelector('[data-rw-grid]'); if (!grid) return;
    var cards = all(grid, '[data-rw-card]'), fbtn = all(root, '[data-rw-f]');
    var load = root.querySelector('[data-rw-load]'), foot = load ? load.parentNode : null, status = root.querySelector('[data-rw-status]');
    var ini = parseInt(root.getAttribute('data-initial') || '6', 10) || 6, step = parseInt(root.getAttribute('data-step') || '6', 10) || 6;
    var more = root.getAttribute('data-more') || 'Read more', less = root.getAttribute('data-less') || 'Show less';
    var tpl = root.getAttribute('data-showing') || '', cur = 'all', limit = ini;

    function match(c) { return cur === 'all' || (cur === 'photos' ? c.getAttribute('data-ph') === '1' : c.getAttribute('data-f') === cur); }
    function clampCheck(c) {
      var t = c.querySelector('[data-rw-txt]'), b = c.querySelector('[data-rw-more]');
      if (!t || !b || c.hidden) return;
      if (c.classList.contains('is-open')) { b.hidden = false; return; }
      b.hidden = !(t.scrollHeight > t.clientHeight + 2);
    }
    var MQ = window.matchMedia ? matchMedia('(min-width: 750px)') : null;
    function wall() {   // mur od 750 px: wysokość karty (+ jej dolny odstęp) → liczba wierszy siatki grid-auto-rows z CSS
      var many = !MQ || MQ.matches, row = parseFloat(getComputedStyle(grid).gridAutoRows) || 2;
      cards.forEach(function (c) {
        if (c.hidden) return;
        if (!many) { c.style.gridRowEnd = ''; return; }
        var inn = c.firstElementChild, pb = parseFloat(getComputedStyle(c).paddingBottom) || 0;
        var h = (inn ? inn.getBoundingClientRect().height : c.getBoundingClientRect().height) + pb;
        c.style.gridRowEnd = 'span ' + Math.max(1, Math.ceil(h / row));
      });
    }
    function render(focusFrom) {
      var m = cards.filter(match), n = 0, firstNew = null;
      cards.forEach(function (c) {
        var show = match(c) && n < limit;
        if (match(c)) n++;
        if (show && c.hidden && focusFrom !== undefined && !firstNew) firstNew = c;
        c.hidden = !show;
      });
      var shown = Math.min(limit, m.length);
      if (status && tpl) status.textContent = tpl.replace('{shown}', shown).replace('{total}', m.length);
      if (foot) foot.hidden = shown >= m.length;
      cards.forEach(clampCheck);
      wall();
      if (firstNew) { var t = firstNew.querySelector('.sk-rw-t') || firstNew; t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: false }); }
    }

    fbtn.forEach(function (b) {
      b.addEventListener('click', function () {
        cur = b.getAttribute('data-rw-f'); limit = ini;
        fbtn.forEach(function (x) { var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        render();
      });
    });
    if (load) load.addEventListener('click', function () { limit += step; render(true); });
    cards.forEach(function (c) {
      var b = c.querySelector('[data-rw-more]'); if (!b) return;
      b.addEventListener('click', function () {
        var open = !c.classList.contains('is-open');
        c.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.textContent = open ? less : more;
        wall();
      });
    });

    root.classList.add('sk-rw-js');
    grid.classList.add('is-wall');
    render();
    var rq = false;
    window.addEventListener('resize', function () { if (!rq) { rq = true; requestAnimationFrame(function () { rq = false; cards.forEach(clampCheck); wall(); }); } });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { cards.forEach(clampCheck); wall(); });
    window.addEventListener('load', function () { cards.forEach(clampCheck); wall(); });
  }

  function init() {
    all(document, '[data-sk-ugc]').forEach(ugc);
    all(document, '[data-sk-rw]').forEach(rw);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
